import type { PhoneNumber } from 'lib-shared-legacy-types';
import { formatInternational } from 'lib-shared-phone-numbers';

type PrettyNumberProps = {
  number: Pick<PhoneNumber, 'e164_format'> | null;
};

const PrettyNumber = ({ number }: PrettyNumberProps) => {
  const { e164_format = '' } = number || {};
  const prettyNumber = formatInternational(e164_format) || e164_format;

  return <span>{prettyNumber}</span>;
};

export default PrettyNumber;
